import React, { useCallback, useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import useFetchData from '../../../../../../hooks/useFetchData'
import LearningAreaOverview from './LearningAreaOverview'
import YourStrengthsOrFocusOn from './YourStrengthsOrFocusOn'
import RecentFeedback from './RecentFeedback'
import { getDashboardStudent } from '../../../../../../services/dashboard/dashboard.service'
import { faCrosshairs, faStar } from '@fortawesome/pro-solid-svg-icons'
import VCE from './VCE'

const ForStudent = ({ userId }) => {
  const { isLoading: isLoadingFeedback, data: dataFeedback } = useFetchData(
    `dashboard/student/${userId}/recent-feedback`
  )
  const { isLoading: isPeriodicalReportLoading, data: dataPeriodicalReport } = useFetchData(
    `dashboard/student/${userId}/periodical-report`
  )
  const currentLA = useSelector((state) => state?.assessment?.currentLearningArea || null)
  const [isLoadingDashboard, setIsLoadingDashboard] = useState(false)
  const [data, setData] = useState()
  const onLoad = useCallback(async () => {
    if (currentLA?._id) {
      try {
        setIsLoadingDashboard(true)
        const response = await getDashboardStudent(userId, {
          elementStructureId: currentLA?.elementStructureId,
          elementId: currentLA?._id,
          curriculumId: currentLA?.curriculumId,
          curriculumCode: currentLA?.curriculumCode
        })
        if (response?.error || !response?.data) {
          return
        }
        setData(response?.data)
      } catch (error) {
        console.error(error)
      } finally {
        setIsLoadingDashboard(false)
      }
    }
  }, [currentLA?._id])
  useEffect(() => {
    onLoad()
  }, [onLoad])

  return (
    <div className='flex flex-col gap-4 pb-4 py-8'>
      <LearningAreaOverview isLoadingDashboard={isLoadingDashboard} data={data} />
      {(dataPeriodicalReport?.VIC?.yourStrengths?.length > 0 ||
        dataPeriodicalReport?.VIC?.yourAreasToFocus?.length > 0) && (
        <div
          className='grid  gap-4'
          // MF-529 — minmax(0, 1fr) so long strengths/focus text can't widen a column past the viewport
          style={{
            gridTemplateColumns:
              dataPeriodicalReport?.VIC?.yourStrengths &&
              dataPeriodicalReport?.VIC?.yourStrengths.length > 0 &&
              dataPeriodicalReport?.VIC?.yourAreasToFocus &&
              dataPeriodicalReport?.VIC?.yourAreasToFocus.length > 0
                ? 'repeat(2, minmax(0, 1fr))'
                : 'minmax(0, 1fr)'
          }}
        >
          {dataPeriodicalReport?.VIC?.yourStrengths &&
            dataPeriodicalReport?.VIC?.yourStrengths.length > 0 && (
              <YourStrengthsOrFocusOn
                icon={faStar}
                title='Your strengths'
                bgColor='#bcd4eb'
                border='#5e9ed6'
                isLoading={isPeriodicalReportLoading}
                data={dataPeriodicalReport?.VIC?.yourStrengths || []}
              />
            )}
          {dataPeriodicalReport?.VIC?.yourAreasToFocus &&
            dataPeriodicalReport?.VIC?.yourAreasToFocus.length > 0 && (
              <YourStrengthsOrFocusOn
                icon={faCrosshairs}
                title='Areas to focus on'
                bgColor='#FBEBD3'
                border='#f5b453'
                isLoading={isPeriodicalReportLoading}
                data={dataPeriodicalReport?.VIC?.yourAreasToFocus || []}
              />
            )}
        </div>
      )}
      {dataPeriodicalReport?.VCE?.length > 0 && (
        <VCE isLoadingCurriculum={isPeriodicalReportLoading} data={dataPeriodicalReport?.VCE || []} />
      )}
      <RecentFeedback data={dataFeedback || []} isLoading={isLoadingFeedback} />
    </div>
  )
}

export default ForStudent
